import React from 'react'
import GuestTabs from './GuestTabs'

export default function Index() {
  return (
    <GuestTabs/>
  )
}
